import { Component, OnInit } from '@angular/core';
import { ProjectDetailInstance } from '../project-detail.instance';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditWidgetModalComponent } from '../../../widgets/edit-widget-modal/edit-widget-modal.component';
import { WidgetService } from '../../../widgets/widget.service';
import { Widget } from '../../../models/widget';
import { ModalService } from '../../../core/modal.service';

@Component({
  selector: 'app-project-detail-widgets',
  templateUrl: './project-detail-widgets.component.html',
  styleUrls: ['./project-detail-widgets.component.scss']
})
export class ProjectDetailWidgetsComponent implements OnInit {
  widgets: Widget[];

  constructor(private widgetService: WidgetService,
              private instance: ProjectDetailInstance,
              private modal: ModalService) {
    this.instance.$project.subscribe(project => {
      if (project) {
        this.loadWidgets();
      }
    });
  }

  ngOnInit() {

  }

  createWidget() {
    const modalRef = this.modal.open(EditWidgetModalComponent);
    modalRef.componentInstance.initCreate(this.project);
    modalRef.result
      .then(widget => {
        if (widget) {
          this.loadWidgets();
        }
      }).catch(() => {
    });
  }


  get project() {
    return this.instance.project;
  }


  private loadWidgets() {
    this.widgetService.getForProject(this.project).subscribe(widgets => {
      this.widgets = widgets;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/detail/project-detail-widgets/project-detail-widgets.component.ts